export const GET_CARD_START = "GET_CADR_START";
export const GET_CARD_SUCCESS = "GET_CARD_SUCCESS";
export const GET_CARD_FAILED = "GET_CARD_FAILED";

export const GET_CARD_BY_ID_START = "GET_CARD_BY_ID_START";
export const GET_CARD_BY_ID_SUCCESS = "GET_CARD_BY_ID_SUCCESS";
export const GET_CARD_BY_ID_FAILED = "GET_CARD_BY_ID_FAILED";
